import React, { FC, ReactNode } from 'react';
import { Spin as AntdSpin } from 'antd';

interface IComponentProps {
  children?: ReactNode;
  spinning?: boolean;
  small?: boolean;
}

export const Spin: FC<IComponentProps> = ({ children, spinning = true, small }) => {
  return (
    <AntdSpin
      spinning={spinning}
      indicator={
        !small ? (
          <div className="spin-indicator">
            <span className="spin-indicator-spin"></span>
          </div>
        ) : undefined
      }
    >
      {children}
    </AntdSpin>
  );
};
